// extracted by mini-css-extract-plugin
export default {"topToolbar":"wHKoRL","bottomToolbar":"S4WpgP"};